import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { useFlow } from '@router/stackflow';
import { Fragment } from 'react';

import useNearShop from './hooks/useNearShop';

function NearBy() {
  const shop = useNearShop();
  const { push } = useFlow();
  if (shop) {
    const {
      thumbnailImageUrl, name, address, id,
    } = shop;
    return (
          <Container>
              <Text size='lg' fontWeight='bold'>
                  가까운 매장에서 주문
              </Text>
              <Content onClick={() => push('ItemsActivity', { shopId: id, type: 'ALL' })}>
                  <Image src={thumbnailImageUrl}
                         width={48}
                         height={48} />
                  <Column spacing={4} css={css`
                      flex: 1;
                      overflow: hidden;`}>
                      <Text size='lg' fontWeight='medium' css={textCss}>
                          {name}
                      </Text>
                      <Text color={colors.gray6} size='s' css={textCss}>{address}</Text>
                  </Column>
                  <ArrowLineRight size={18}/>
              </Content>
          </Container>
    );
  }
  return (<Fragment/>);
}

const Container = styled.div`
    padding: 0 16px;
    margin-bottom: 48px;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    width: 100%;
`;

const Content = styled.div`
    padding: 16px;
    background-color: ${colors.gray1};
    border-radius: 8px;
    display: flex;
    align-items: center;
    column-gap: 12px;
`;

const textCss = css`
    text-overflow: ellipsis;
    overflow: hidden;
`;

export default NearBy;
